import { FC, useMemo } from "react"
import CellStatusIcon from "./CellStatusIcon"
import Vitals from "./Vitals"
import { CellStatus, UserStatus } from "."
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { IconColor, IconProps } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"
import { ButtonVariant, ColorVariant } from "@/types/index"

interface CellDescriptionProps {
   cellStatus?: CellStatus
   userStatus: UserStatus
   noVitals?: boolean
   humanPresenceInVacant: boolean
   bpm?: number
   bpmStabilityScore?: number
   rpm?: number
   rpmStabilityScore?: number
   hideVitals: boolean
   typefaceIconColor: IconColor
   iconSize?: IconProps["size"]
   onTriggerTestAlarm?: () => void
}

const CellDescription: FC<CellDescriptionProps> = ({
   cellStatus,
   userStatus,
   noVitals = false,
   humanPresenceInVacant,
   bpm,
   bpmStabilityScore,
   rpm,
   rpmStabilityScore,
   hideVitals,
   typefaceIconColor,
   iconSize,
   onTriggerTestAlarm,
}) => {
   const title = useMemo(() => {
      if (cellStatus === CellStatus.INMATE_TRANSFER) {
         return "Status:"
      }
   }, [cellStatus])

   const description = useMemo(() => {
      if (cellStatus === CellStatus.INMATE_TRANSFER) {
         return "Inmate expected"
      }
   }, [cellStatus])

   return (
      <div>
         <div
            className="cell-card__title"
            data-testid={TestId.CELL_CARD_TITLE}
         >
            {title}
         </div>
         <div className="cell-card__description">
            {onTriggerTestAlarm && (
               <Button
                  className="cell-card__test-alarm-button"
                  testId={TestId.TEST_ALARM_BUTTON}
                  variant={ButtonVariant.SMALL}
                  color={ColorVariant.CERISE}
                  iconName="alerts"
                  iconSize="12"
                  iconPosition={ButtonIconPosition.LEFT}
                  onClick={(e) => {
                     e.stopPropagation()
                     e.preventDefault()
                     onTriggerTestAlarm()
                  }}
               >
                  Test alarm
               </Button>
            )}
            <span>{description}</span>
            {!hideVitals && !noVitals && userStatus !== UserStatus.MOVING && (
               <Vitals
                  bpm={bpm}
                  rpm={rpm}
                  bpmStabilityScore={bpmStabilityScore}
                  rpmStabilityScore={rpmStabilityScore}
                  typefaceColor={typefaceIconColor}
                  testId={TestId.CELL_CARD_VITALS}
               />
            )}
            <CellStatusIcon
               typeface={typefaceIconColor}
               cellStatus={cellStatus}
               isMoving={userStatus === UserStatus.MOVING}
               humanPresenceInVacant={humanPresenceInVacant}
               size={iconSize}
            />
         </div>
      </div>
   )
}
export default CellDescription
